import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby", "aria-describedby"]
const _hoisted_2 = {
  class: "confirm-icon",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_4 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_5 = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "confirm-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "confirm-fade" }, {
      default: _withCtx(() => [
        (_ctx.state.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "confirm-backdrop",
              role: "presentation",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["self"]))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["confirm-dialog", `confirm-${_ctx.state.variant}`]),
                role: "alertdialog",
                "aria-modal": "true",
                "aria-labelledby": _ctx.titleId,
                "aria-describedby": _ctx.messageId,
                onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["prevent"]), ["esc"])),
                tabindex: "-1",
                ref: "dialogRef"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.state.variant === 'danger')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[4] || (_cache[4] = [
                        _createElementVNode("path", {
                          d: "M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1)
                      ])))
                    : (_ctx.state.variant === 'warning')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[5] || (_cache[5] = [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10"
                          }, null, -1),
                          _createElementVNode("path", {
                            d: "M12 8v4m0 4h.01",
                            "stroke-linecap": "round"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[6] || (_cache[6] = [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10"
                          }, null, -1),
                          _createElementVNode("path", {
                            d: "M12 16v-4m0-4h.01",
                            "stroke-linecap": "round"
                          }, null, -1)
                        ])))
                ]),
                _createElementVNode("h3", {
                  id: _ctx.titleId,
                  class: "confirm-title"
                }, _toDisplayString(_ctx.state.title), 9, _hoisted_6),
                _createElementVNode("p", {
                  id: _ctx.messageId,
                  class: "confirm-message"
                }, _toDisplayString(_ctx.state.message), 9, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "confirm-btn confirm-btn-cancel",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                  }, _toDisplayString(_ctx.state.cancelText), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["confirm-btn confirm-btn-confirm", `confirm-btn-${_ctx.state.variant}`]),
                    ref: "confirmBtnRef",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
                  }, _toDisplayString(_ctx.state.confirmText), 3)
                ])
              ], 42, _hoisted_1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}